
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18 0a2 2 0 100 4h7.172l-6.586 6.586a2 2 0 102.828 2.828L28 6.828V14a2 2 0 104 0V2a2 2 0 00-2-2H18z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M14 32a2 2 0 100-4H6.828l6.586-6.586a2 2 0 10-2.828-2.828L4 25.172V18a2 2 0 10-4 0v12a2 2 0 002 2h12z","fill":"currentColor"}})])
          )
        }
      }
    